import React from "react";
import {Field, ErrorMessage} from "formik";
import styled from "styled-components";

const TextareaFormik = (props) => {

    const {label, name, ...rest} = props

    return (
        <StyledTextArea>
            <label htmlFor="name"> {label} </label>
            <Field as='textarea' id={name} name={name} {...rest}/>
            <ErrorMessage
                name={name}
                render={msg => <div><p className="error-text"> {msg} </p></div>}
            />
        </StyledTextArea>
    )
}

const StyledTextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;

  textarea {
    min-height: 100px;
  }
`
export default TextareaFormik;